import { SVGProps, Ref, forwardRef } from 'react';

export const LoaderOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 3.733A12.267 12.267 0 1 0 28.267 16h2.4A14.667 14.667 0 1 1 16 1.333z"
                fill="currentColor"
            />
        </g>
    </svg>
));
LoaderOutlinedSize32Glyph.displayName = 'LoaderOutlinedSize32Glyph';
